<mat-card class="width-steps" data-cy="KalenderPage">
    <mat-card-header>
        <mat-card-title>Termine</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <!-- Header -->
        <div class="flex-container-header" data-cy="KalenderHeader">
            <!-- Vor - Heute - Zurück Buttons -->
            @if (view !== CalendarView.Day) {
                <div class="flex-grow" style="text-align: center">
                    <button
                        mat-raised-button
                        mwlCalendarPreviousView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="viewDateChange()"
                        aria-label="einen Zeitraum zurück wechseln">
                        Zurück
                    </button>
                    <button
                        mat-raised-button
                        mwlCalendarToday
                        [(viewDate)]="viewDate"
                        aria-label="zum aktuellen Datum wechseln">
                        Heute
                    </button>
                    <button
                        mat-raised-button
                        mwlCalendarNextView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="viewDateChange()"
                        aria-label="einen Zeitraum in die Zukunft wechseln">
                        Vor
                    </button>
                </div>
            }
            @if (view === CalendarView.Day) {
                <div class="flex-grow" style="text-align: center">
                    @if (viewDate > minKalenderDate) {
                        <button
                            mat-raised-button
                            (click)="viewDate.setFullYear(viewDate.getFullYear() - 1); viewDateChange()"
                            aria-label="ein Jahr zurück wechseln">
                            Zurück
                        </button>
                    }
                    <button
                        mat-raised-button
                        (click)="viewDate = heute; viewDateChange()"
                        aria-label="zum aktuellen Jahr wechseln">
                        Heute
                    </button>
                    @if (viewDate < maxKalenderDate) {
                        <button
                            mat-raised-button
                            (click)="viewDate.setFullYear(viewDate.getFullYear() + 1); viewDateChange()"
                            aria-label="ein Jahr in die Zukunft wechseln">
                            Vor
                        </button>
                    }
                </div>
            }

            <!-- Anzeige Text -->
            @if (view !== CalendarView.Day) {
                <div class="flex-grow" style="text-align: center">
                    <h3>{{ viewDate | calendarDate: view + 'ViewTitle' : 'de' }}</h3>
                </div>
            }
            @if (view === CalendarView.Day) {
                <div class="flex-grow" style="text-align: center">
                    <h3>{{ viewDate.getFullYear() }}</h3>
                </div>
            }

            <!-- Liste - Monat Buttons -->
            <div class="flex-grow" style="text-align: center">
                <mat-button-toggle-group name="Kalenderansicht" aria-label="Kalenderansicht" [(ngModel)]="view">
                    <mat-button-toggle [value]="CalendarView.Day" aria-label="Zeige Termine in Listenansicht"
                        >Liste</mat-button-toggle
                    >
                    <mat-button-toggle [value]="CalendarView.Month" aria-label="Zeige Termine in Monatsansicht"
                        >Monat</mat-button-toggle
                    >
                    <mat-button-toggle [value]="CalendarView.Week" aria-label="Zeige Termine in Wochenansicht"
                        >Woche</mat-button-toggle
                    >
                </mat-button-toggle-group>
            </div>
        </div>

        <div class="flex-container">
            @if (authService.hasRight('new-kalender') || authService.hasRight('edit-kalender')) {
                <mat-accordion data-cy="KalenderCard">
                    <mat-expansion-panel hideToggle [expanded]="!deviceScaleService.isMobileOrTablet()">
                        <mat-expansion-panel-header>
                            <mat-panel-title> Kalenderliste </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-selection-list #kalList [(ngModel)]="selectedKalender" (selectionChange)="filterTermine()">
                            @for (item of kalender; track item) {
                                <div class="noWrap" class="flex-row">
                                    <button
                                        mat-icon-button
                                        (click)="openKalenderDialog(item)"
                                        data-cy="kalenderEditBtn">
                                        <mat-icon [style.color]="item.farbe">settings</mat-icon>
                                    </button>
                                    <mat-list-option [value]="item" data-cy="KalenderEntry">
                                        {{ item.titel }}
                                        @if (item.oeffentlich) {
                                            <mat-icon matTooltip="Öffentlicher Kalender">public</mat-icon>
                                        }
                                    </mat-list-option>
                                </div>
                            }
                        </mat-selection-list>
                        @if (authService.hasRight('new-kalender')) {
                            <button
                                mat-raised-button
                                matTooltip="neuen Kalender"
                                data-cy="new-Kalender"
                                (click)="openKalenderDialog()">
                                <mat-icon>add</mat-icon>
                                Weiteren Kalender
                            </button>
                        }
                    </mat-expansion-panel>
                </mat-accordion>
            }

            <div class="flex-grow">
                <!-- Kalender Listenansicht -->
                @switch (view) {
                    @case (CalendarView.Day) {
                        @if (isLoading) {
                            <mat-spinner class="spinner"></mat-spinner>
                        } @else {
                            <section class="table-container mat-elevation-z8">
                                <table mat-table [dataSource]="termine" multiTemplateDataRows data-cy="terminListe">
                                    <ng-container matColumnDef="color">
                                        <th mat-header-cell *matHeaderCellDef aria-hidden="true"></th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            aria-hidden="true"
                                            (click)="
                                                openTerminDetails(element);
                                                element.beschreibung === ''
                                                    ? null
                                                    : (expandedElement = expandedElement === element ? null : element)
                                            "
                                            [style.background-color]="element.kalender?.farbe || '#FFFFFF'"></td>
                                    </ng-container>
                                    <ng-container matColumnDef="datum">
                                        <th mat-header-cell *matHeaderCellDef>Datum</th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            (click)="
                                                openTerminDetails(element);
                                                element.beschreibung === ''
                                                    ? null
                                                    : (expandedElement = expandedElement === element ? null : element)
                                            ">
                                            {{ element.datum | date }}
                                            {{
                                                (element.datum | date: 'HH:mm') != '00:00'
                                                    ? ' ' + (element.datum | date: 'HH:mm') + ' Uhr'
                                                    : ''
                                            }}
                                            {{
                                                element.datum_bis &&
                                                (element.datum | date) !== (element.datum_bis | date)
                                                    ? ' - ' + (element.datum_bis | date)
                                                    : ''
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="betreff">
                                        <th mat-header-cell *matHeaderCellDef>Betreff</th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            (click)="
                                                openTerminDetails(element);
                                                element.beschreibung === ''
                                                    ? null
                                                    : (expandedElement = expandedElement === element ? null : element)
                                            ">
                                            {{ element.betreff }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="mobile">
                                        <th mat-header-cell *matHeaderCellDef>Termine</th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            (click)="
                                                openTerminDetails(element);
                                                element.beschreibung === ''
                                                    ? null
                                                    : (expandedElement = expandedElement === element ? null : element)
                                            ">
                                            <div class="date">
                                                <b>
                                                    {{ element.datum | date }}
                                                    {{
                                                        (element.datum | date: 'HH:mm') != '00:00'
                                                            ? ' ' + (element.datum | date: 'HH:mm') + ' Uhr'
                                                            : ''
                                                    }}
                                                    {{
                                                        element.datum_bis && element.datum !== element.datum_bis
                                                            ? ' - ' + (element.datum_bis | date)
                                                            : ''
                                                    }}
                                                </b>
                                            </div>
                                            <div class="text">{{ element.betreff }}</div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="buttonsMobile">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element">
                                            @if (element.kalender.editable || showNewTermin) {
                                                <button
                                                    mat-icon-button
                                                    matTooltip="mehr Details"
                                                    [matMenuTriggerFor]="menu"
                                                    data-cy="terminMenueBtn">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                            }
                                            <mat-menu #menu="matMenu">
                                                @if (element.kalender.editable) {
                                                    <button
                                                        mat-menu-item
                                                        (click)="editTerminEntry(element)"
                                                        data-cy="terminEditBtn">
                                                        Ändern
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                }
                                                @if (showNewTermin) {
                                                    <button
                                                        mat-menu-item
                                                        (click)="copyTerminEntry(element)"
                                                        data-cy="terminCopyBtn">
                                                        Termin kopieren
                                                        <mat-icon>content_copy</mat-icon>
                                                    </button>
                                                }
                                                @if (element.kalender.editable) {
                                                    <button
                                                        mat-menu-item
                                                        (click)="deleteTerminEntry(element)"
                                                        data-cy="terminDeleteBtn">
                                                        Löschen
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                }
                                            </mat-menu>
                                        </td>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="expand">
                                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            (click)="
                                                element.beschreibung === ''
                                                    ? null
                                                    : (expandedElement = expandedElement === element ? null : element)
                                            ">
                                            @if (element.beschreibung && element.beschreibung !== '') {
                                                <button
                                                    mat-icon-button
                                                    aria-label="expand row"
                                                    (click)="
                                                        expandedElement = expandedElement === element ? null : element;
                                                        $event.stopPropagation()
                                                    ">
                                                    @if (expandedElement !== element) {
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    } @else {
                                                        <mat-icon>keyboard_arrow_up</mat-icon>
                                                    }
                                                </button>
                                            }
                                        </td>
                                    </ng-container> -->

                                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                    <!-- <ng-container matColumnDef="expandedDetail">
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            [attr.colspan]="columnsToDisplayWithExpand.length">
                                            <div
                                                class="termin-detail"
                                                [@detailExpand]="
                                                    element === expandedElement ? 'expanded' : 'collapsed'
                                                ">
                                                <div
                                                    class="termin-description"
                                                    [innerHTML]="element.beschreibung | linky | nl2br"></div>
                                            </div>
                                        </td>
                                    </ng-container> -->

                                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>

                                    <tr
                                        mat-row
                                        *matRowDef="let element; columns: columnsToDisplayWithExpand; let i = index"
                                        class="termin-row"
                                        [class.termin-row]="expandedElement === element"
                                        data-cy="dataRow"
                                        [attr.id]="'termin-' + element.id"></tr>
                                    <!-- <tr
                                        mat-row
                                        *matRowDef="let row; columns: ['expandedDetail']"
                                        class="example-detail-row"
                                        data-cy="detailRow"></tr> -->

                                    <tr class="mat-mdc-row mdc-data-table__row" *matNoDataRow>
                                        <td
                                            class="mat-mdc-cell mdc-data-table__cell"
                                            style="text-align: center"
                                            [colSpan]="columnsToDisplayWithExpand.length">
                                            Keine Termine zum Anzeigen vorhanden
                                        </td>
                                    </tr>
                                </table>
                            </section>
                        }
                    }
                    @case (CalendarView.Month) {
                        <mwl-calendar-month-view
                            [viewDate]="viewDate"
                            (dayClicked)="dayClicked($event.day)"
                            (eventClicked)="handleEvent('Clicked', $event.event)"
                            [activeDayIsOpen]="activeDayIsOpen"
                            [events]="events"
                            [weekStartsOn]="1">
                        </mwl-calendar-month-view>
                    }
                    @case (CalendarView.Week) {
                        <mwl-calendar-week-view
                            [viewDate]="viewDate"
                            [events]="events"
                            [weekStartsOn]="1"
                            (eventClicked)="handleEvent('Clicked', $event.event)"></mwl-calendar-week-view>
                    }
                }
            </div>
        </div>
    </mat-card-content>
</mat-card>

@if (showNewTermin) {
    <button
        mat-fab
        matTooltip="neuen Termin"
        [ngClass]="'md-fab md-fab-bottom-right' + (deviceScaleService.isMobileOrTablet() ? '-mobile' : '')"
        color="primary"
        aria-label="Add a Entry"
        (click)="newTerminEntry()"
        data-cy="fabButton">
        <mat-icon>add</mat-icon>
    </button>
}
